import Joi from "joi";
import formValidationService from "../../../../../../common/utils/validation/form-validation.service";
import DriverAddCarOwnershipType from "../types/driver-add-car-ownership-type";
import userTranslationsHelper from "../../../../../../languages/user-translations.helper";

const validateMake = (value: string) => {
  const validationSchema = Joi.string().max(50).trim().required();

  return formValidationService.validate(value, validationSchema);
};

const validateModel = (value: string) => {
  const validationSchema = Joi.string().max(50).trim().required();

  return formValidationService.validate(value, validationSchema);
};

const validateProductionYear = (value: number | null) => {
  const validationSchema = Joi.number()
    .min(1971)
    .max(new Date().getFullYear())
    .required();

  return formValidationService.validate(value, validationSchema);
};

const validateNumberOfSeats = (value: number | null) => {
  const validationSchema = Joi.number().min(2).max(25).required();

  return formValidationService.validate(value, validationSchema);
};

const validateRegistrationNumber = (value: string) => {
  const registrationPattern = new RegExp(`^[A-Z0-9]*$`);
  const validationSchema = Joi.string()
    .min(4)
    .max(8)
    .trim()
    .pattern(registrationPattern)
    .required();

  return formValidationService.validate(value, validationSchema);
};

const validateOwnership = (value: DriverAddCarOwnershipType | null) => {
  const translations = userTranslationsHelper.getDriverAddTranslations();

  const validationSchema = Joi.string()
    .valid(...Object.values(DriverAddCarOwnershipType))
    .required()
    .messages({
      "any.only": translations.selectComponentNotificationError,
    });

  return formValidationService.validate(value, validationSchema);
};

const driverAddVehicleFormValidationService = {
  validateMake,
  validateModel,
  validateProductionYear,
  validateNumberOfSeats,
  validateRegistrationNumber,
  validateOwnership,
};

export default driverAddVehicleFormValidationService;
